import React from 'react';
import { StatCard } from '../../Nav_DataComponents/StatCard/StatCard';
import { GrowthDeclineIndicator } from '../../Nav_DataComponents/GrowthDeclineIndicator/GrowthDeclineIndicator';
import type { KpiCardProps } from './types';

// ─── KpiCard ──────────────────────────────────────────────────────────────────

export function KpiCard({
  title,
  value,
  trend,
  trendLabel,
  icon,
  className,
}: KpiCardProps) {
  const trendData =
    trend !== undefined
      ? {
          direction: (trend > 0 ? 'up' : trend < 0 ? 'down' : 'flat') as 'up' | 'down' | 'flat',
          value: `${Math.abs(trend)}%`,
        }
      : undefined;

  return (
    <div className={className}>
      <StatCard
        title={title}
        value={value}
        icon={icon}
        variant={trendData ? 'trend' : 'default'}
        trend={trendData}
        comparisonText={trendLabel}
      />
    </div>
  );
}
